import React from 'react';
import {withSuspense} from '@/components/hocs/withSuspense';

const LazyFooter = withSuspense(React.lazy(() => import('./Footer')));

export {LazyFooter as Footer};
